import { Filter, Target } from "lucide-react";
import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SolidButton } from "../../global/SolidButton";
import { CalendarBlank } from "phosphor-react";
import { MyModal } from "../../global/MyModal";
import { MyCalModel } from "../../global/MyCalModel";
import DatePicker from "react-datepicker";

import MyLoader from "../../util/MyLoader";
import { getAllPayoutTrans } from "../apps_manage/api";
import Pagination from "../../util/Pagination";
import MyTooltip from "../../tools/MyTooltip";

export default function PayoutTrans() {
  const type = [
    { id: 1, label: "All", value: "all" },
    { id: 2, label: "Success", value: "success" },
    { id: 3, label: "Pending", value: "pending" },
    { id: 4, label: "Failed", value: "failed" },
  ];
  const [activeTab, setActiveTab] = useState(1);
  const navigate = useNavigate();
  const handleTabClick = (tabId) => {
    const selectedTab = type.find((item) => item.id === tabId);

    if (!selectedTab) return;

    navigate(`/payout/transactions?status=${selectedTab.value}`);
    setActiveTab(tabId);
  };

  const [isOpenCal, setIsOpenCal] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  // pagination state

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);

  const getTransactions = async () => {
    try {
      const response = await getAllPayoutTrans({
        page: page,
        limit: limit,
        search: "",
        //  status: type[activeTab - 1].value,
      });
      if (response.status === 200) {
        const data = response?.data;
        setTransactions(data.transactions || []);
        setTotal(data?.total);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      getTransactions();
    }, 400);

    return () => clearTimeout(timer);
  }, [activeTab, page, limit]);

  if (loading) return <MyLoader />;

  return (
    <Fragment>
      <div className="space-y-4 w-full relative">
        <div className="flex items-center justify-between h-auto  space-x-2 md:space-x-4">
          {/* tabs */}
          <div className=" flex items-center justify-between">
            <div className="flex items-center gap-2 px-2 py-2 bg-slate-300/25 dark:bg-slate-900/80 backdrop-blur-xl rounded-lg">
              {type.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => handleTabClick(tab.id)}
                  className={`text-xs px-3 py-1.5 rounded-md transition-all duration-200 
        ${
          tab.id === activeTab
            ? "bg-white dark:bg-slate-800 text-black dark:text-white shadow-sm"
            : "text-slate-600 dark:text-slate-400 hover:bg-white/50 dark:hover:bg-slate-800/50"
        }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
          {/* Search */}
          <div className="ml-auto w-full md:w-50 mr-0">
            <input
              type="search"
              placeholder="Search by order id..."
              //   value={search}
              //   onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  //        setPage(1);
                  //         setAppliedSearch(search.trim());
                }
              }}
              className=" text-xs py-1.5 px-4 bg-slate-400/20 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
            />
          </div>
          {/* date picker */}
          <div
            onClick={() => setIsOpenCal(true)}
            className="flex items-center justify-start text-xs border rounded-lg 
          mr-8 dark:border-slate-400 border-slate-300 px-2 py-1.5 space-x-2 "
          >
            <CalendarBlank
              size={18}
              className="text-slate-600 dark:text-slate-400 "
            />
            <span className="text-slate-600 dark:text-slate-400 line-clamp-1">
              Pick date range
            </span>
          </div>
          {/* filter */}
          <SolidButton
            className="py-1 h-[30px]   px-2   "
            //   onClick={() => setIsModalOpen(true)}
          >
            <Filter size={14} />
            <span>Filter</span>
          </SolidButton>
        </div>
        {/* table */}
        <div
          className="bg-white/80 dark:bg-slate-900/80
               backdrop-blur-xl rounded-2xl  
               border border-state-200/50 dark:border-slate-700/50 
                w-full 
                pb-4
               overflow-x-auto       
               mt-4 
              "
        >
          <div className="overflow-x-auto">
            <table className="w-full text-xs text-left">
              <thead>
                <tr className="border-b border-slate-300/40 text-slate-600 dark:text-slate-400">
                  <th className="px-4 py-3 font-semibold text-start space-x-2">
                    Order ID
                  </th>
                  <th className=" py-3 font-semibold text-start">Mode</th>
                  <th className=" py-3 font-semibold text-start">App</th>
                  <th className=" py-3 font-semibold text-start">Amount</th>
                  <th className=" py-3 font-semibold text-start">Target</th>
                  <th className=" py-3 font-semibold text-start ps-4">Status</th>
                  <th className=" py-3 font-semibold text-start">Callback</th>
                  <th className="py-3 font-semibold text-start">Created</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((transaction, index) => (
                  <tr
                    key={index}
                    className="border-b border-slate-300/40 text-start text-xs text-slate-700 dark:text-slate-300"
                  >
                    <td className="ps-4 py-3 max-w-50">
                      {transaction.order_id}
                    </td>
                    <td className="py-3 uppercase text-blue-400">
                      {transaction.service}
                    </td>
                    <td className=" py-3">{transaction.app_name}</td>
                    <td className=" py-3 text-green-400 font-medium">
                      {"₹" + transaction.amount}
                    </td>
                    <td className=" py-3">{transaction.target}</td>
                    <td className=" py-3 px-4  font-semibold">
                      {transaction.status < 1 ? (
                        <div className="flex rounded-2xl py-1  bg-red-500/20 items-center justify-center gap-1">
                          <span className="text-red-600  ">Failed</span>
                          <MyTooltip
                            border={1}
                            tpId={transaction.id + ""}
                            msg={[transaction.fail_reason]}
                          />
                        </div>
                      ) : (
                        <span className="text-green-600 bg-green-500/20 rounded-2xl py-1 px-2">
                          Success
                        </span>
                      )}
                    </td>
                    <td className=" py-3">
                      <span className="text-xs  text-green-500 bg-green-500/20 rounded-2xl px-2 py-1">
                        Success (200)
                      </span>
                    </td>
                    <td className=" py-3 flex flex-col">
                      <span className="text-slate-600 dark:text-slate-300">
                        {formatDate(transaction.created_at)}
                      </span>
                      <span className="text-slate-600 dark:text-slate-400">
                        {formateTime(transaction.created_at)}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="sticky bottom-0 bg-white dark:bg-slate-900 my-2">
          <Pagination
            page={page}
            limit={limit}
            total={total}
            fixed={false}
            onPageChange={setPage}
            onLimitChange={(l) => {
              setLimit(l);
              setPage(1); // reset to first page
            }}
            constrainTo="#devices-main"
          />
        </div>
      </div>
      <MyCalModel
        isOpen={isOpenCal}
        onClose={() => setIsOpenCal(false)}
        onApply={(dateRange) => {
          // Handle the applied date range
          console.log(dateRange);
        }}
        width="580px"
      ></MyCalModel>
    </Fragment>
  );
}

const formatDate = (date) => {
  return new Date(date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formateTime = (date) => {
  return new Date(date).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};
